export const groupSshOptions = [
    {value: "sentrydev", label: "SENTRYDEV"},
    {value: "sentryinfra", label: "SENTRYINFRA"},
    {value: "sentrysup", label: "SENTRYSUP"},
]